import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

// MUI Theme
import { List, ListItem, ListItemText, Typography, ListItemIcon, ListItemButton } from '@mui/material';
import MyLocationOutlined from '@mui/icons-material/MyLocationOutlined';

// Redux
import { useAppDispatch } from '../../../redux/hook';
import { fetchFacilityGeofences } from '../../../redux/slices/geofenceSlice';

// Types
import { Geofence } from '../../../types/Geofence';
import { FilterableTypes } from '../../../types/FilterableTypes';

// Components
import FilterOptions from './filterOptions';

interface StationGeofenceProp {
  onSeleted: (item: Geofence) => void;
  selectedItem?: Geofence | null;
}

export default function FacilityGeofences(props: StationGeofenceProp): JSX.Element {
  const dispatch = useAppDispatch();
  const defaultFilter = { level: 1, filterType: FilterableTypes.Equals };
  const [data, setData] = useState<Geofence[]>([]);
  const [selectedItem, setSelectedItem] = useState<Geofence | null>(null);
  const [paramFilter, setParamFilter] = useState<any>([defaultFilter]);

  const handleListItemClick = (item) => {
    setSelectedItem(item);
    props.onSeleted(item);
  };

  const loadMoreData = () => {
    dispatch(
      fetchFacilityGeofences({
        filters: paramFilter,
        skip: 0,
        take: 100,
      }),
    ).then((res: any) => {
      if (res.payload.status === 200) {
        setData(res.payload.data.results);
      }
    });
  };

  useEffect(() => {
    loadMoreData();
    if (props.selectedItem) {
      setSelectedItem(props.selectedItem);
    }
  }, [paramFilter, props.selectedItem]);

  const onSearchChange = (txtSearch: string) => {
    if (txtSearch) {
      setParamFilter([
        {
          name: txtSearch,
          filterType: FilterableTypes.Contains,
          or: {
            stationIataCode: txtSearch,
            filterType: FilterableTypes.Contains,
          },
        },
        defaultFilter,
      ]);
      setSelectedItem(null);
    } else {
      setParamFilter([defaultFilter]);
    }
  };

  return (
    <React.Fragment>
      <FilterOptions onSearch={onSearchChange} />

      <InfiniteScroll
        dataLength={data.length}
        next={() => {
          loadMoreData();
        }}
        style={{ display: 'flex', flexDirection: 'column-reverse' }}
        hasMore={false}
        //endMessage={<p>No more data to load.</p>}
        loader={
          <div className='loader' key='loader'>
            Loading ...
          </div>
        }
        scrollableTarget='scrollableDiv'
      >
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {data &&
            data.map((geoStation: Geofence, index) => (
              <ListItem key={index} disablePadding onClick={() => handleListItemClick(geoStation)}>
                <ListItemButton selected={selectedItem?.id === geoStation.id}>
                  <ListItemIcon style={{ minWidth: '30px' }}>
                    <MyLocationOutlined
                      fontSize='small'
                      style={{
                        color: geoStation.coordinates?.length ? 'red' : 'black',
                      }}
                    />{' '}
                  </ListItemIcon>
                  <ListItemText>
                    <Typography sx={{ display: 'inline', fontSize: '13px' }} component='span' color='text.primary'>
                      {geoStation.name}
                    </Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            ))}
        </List>
      </InfiniteScroll>
    </React.Fragment>
  );
}
